import { render, staticRenderFns } from "./svgOrIcon.vue?vue&type=template&id=3169d1ac&scoped=true"
import script from "./svgOrIcon.vue?vue&type=script&lang=js"
export * from "./svgOrIcon.vue?vue&type=script&lang=js"
import style0 from "./svgOrIcon.vue?vue&type=style&index=0&id=3169d1ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3169d1ac",
  null
  
)

export default component.exports